import { Component, OnInit } from '@angular/core';
import {NgForm} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {UserVerificationService} from "../../services/user-verification.service";
import {Location} from "@angular/common";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {ApiEndpoints} from "../../services/api-endpoints";

@Component({ standalone: false, 
  selector: 'app-edit-activation-agreement',
  templateUrl: './edit-activation-agreement.component.html',
})
export class EditActivationAgreementComponent implements OnInit {

  public title;
  public nsId;
  public jsId;
  public nsName;
  public jsName;
  public netIds;
  public joinEuis;
  public nsProtocolVersion;
  public subscriberId;


  constructor(private router: Router,
              private route: ActivatedRoute,
              userVerificationService: UserVerificationService,
              private _location: Location,
              private http: HttpClient) {
    this.getActivationAgreement();
  }

  getActivationAgreement() {
    var url = ApiEndpoints.GET_ACTIVATION_AGREEMENT;
    var body = {
      "nsId": this.route.snapshot.queryParams["nsId"],
      "jsId": this.route.snapshot.queryParams["jsId"]
    };
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'my-auth-token'
    });
    let options =  {headers: headers};
    this.http.post<any>(url, body, options).subscribe(
        data => {
          this.nsId = data.ns_id;
          this.jsId = data.js_id;
          this.subscriberId = data.subscriberId;
        }
      );
    }

  save() {
    //this.verifyRoamingPolicy();

    var body: any = {
      "nsId": this.nsId,
      "jsId": this.jsId,
      "subscriberId": this.subscriberId
    };
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'my-auth-token'
    });
    let options =  {headers: headers};
    var url = ApiEndpoints.CREATE_ACTIVATION_AGREEMENT;

    this.http.post<any>(url, body, options).subscribe(
        data => {
          this._location.back();
        }
      );
  }

  backClicked() {
    this._location.back();
  }

  ngOnInit() {
    this.nsId = this.route.snapshot.queryParams["nsId"];
    this.jsId = this.route.snapshot.queryParams["jsId"];
    this.nsName = this.route.snapshot.queryParams["nsName"];
    this.jsName = this.route.snapshot.queryParams["jsName"];
    this.netIds = this.route.snapshot.queryParams["netIds"];
    this.joinEuis = this.route.snapshot.queryParams["joinEuis"];
  }

}
